export default {"src":"/_next/static/media/01_Telegram_PT.b342ab77.gif","height":261,"width":267};